import React, { FC, MouseEvent, ReactNode, useState } from 'react'
import { Button, CircularProgress, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

export interface ActionsMenuItem {
  label: string
  onClick: () => void
  icon?: ReactNode
  disabled?: boolean
  loading?: boolean
  divider?: boolean
}

interface ActionsMenuProps {
  label: string
  items: ActionsMenuItem[]
}

export const ActionsMenu: FC<ActionsMenuProps> = ({ label, items }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null)
  const isAnyItemLoading = items.some((item) => item.loading)
  const openMenu = (event: MouseEvent<HTMLElement>) => setMenuAnchorEl(event.currentTarget)
  const closeMenu = () => setMenuAnchorEl(null)
  const onItemClick = (item: ActionsMenuItem) => {
    if (item.disabled || item.loading) return
    closeMenu()
    item.onClick()
  }

  return (
    <>
      <Button variant="outlined" size="large" onClick={openMenu} endIcon={isAnyItemLoading ? <CircularProgress size={18} /> : <KeyboardArrowDownIcon />}>
        {label}
      </Button>
      <Menu anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={closeMenu}>
        {items.map((item) => [
          item.divider ? <Divider key={`${item.label}-divider`} /> : null,
          <MenuItem key={item.label} onClick={() => onItemClick(item)} disabled={item.disabled || item.loading}>
            {item.icon || item.loading ? <ListItemIcon>{item.loading ? <CircularProgress size={18} /> : item.icon}</ListItemIcon> : null}
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ])}
      </Menu>
    </>
  )
}
